module.exports = __webpack_public_path__ + "img/checklist.f0c6b1f0.png";